import React, { useEffect, useRef, useState } from "react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/20/solid";
import PaymentPage from "./paymentPage";
import benefitlogo from "../../Assets/IconSVG/benefitLogo.svg";
import Creditlogo from "../../Assets/IconSVG/visaLogo.svg";
import appleLogo from "../../Assets/Images/apple.svg";
import appGal from "../../Assets/Images/appgal.svg";

import googleLogo from "../../Assets/Images/google.svg";

import Apple from "../../Assets/IconSVG/applePay.svg";
import OneAppIcon from "../../Assets/IconSVG/one_app_alsalam_marketplace.svg";
import Flooss from "../../Assets/IconSVG/floos.svg";
import logo from "../../Assets/IconSVG/SolidarityLogo.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import fail from "../../Assets/IconSVG/fail.svg";
import Skeleton from "react-loading-skeleton";
import ApplePayTapSDK from "./applePaySDK";
import ApplePayTapSDKSecondOption from "./applePayTapSDK";
import { ApplePayButton } from "@tap-payments/apple-pay-button";
import { InitiateOneApp } from "./API/PaymentServices";
import { toast, ToastContainer } from "react-toastify";

const MainPaymentPage = () => {
  const [isApplePayVisible, setIsApplePayVisible] = useState(false);
  const [isApplePayLoading, setIsApplePayLoading] = useState(false);
  const [isApplePayReady, setIsApplePayReady] = useState(false);
  const [isQuoteLoading, setIsQuoteLoading] = useState(false);

  const onReadyCalled = useRef(false); // avoid multiple ready triggers

  const handleApplePayReady = () => {
    if (onReadyCalled.current) return;
    onReadyCalled.current = true;

    console.log("✅ Apple Pay is ready (handled in parent)");
    setIsApplePayReady(true);
  };

  // Function to check if the device is iOS and the browser is Safari
  const isApplePayAvailable = () => {
    const isIos =
      /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isMac =
      /Macintosh/.test(navigator.userAgent) &&
      /Safari/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Check if it's Safari and either iOS or Mac
    return isSafari && (isIos || isMac);
  };

  const [isCreditCard, setCreditCard] = useState(false);
  const [isOneAppSelected, setOneAppSelected] = useState(false);
  const [isOneAppSuccess, setOneAppSuccess] = useState(false);
  const [isOneAppError, setOneAppError] = useState(false);

  const [isApplePaySelected, setIsApplePaySelected] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [documents, setDocuments] = useState([]);
  const [File, setFile] = useState("");

  const [paymentData, setPaymentData] = useState({
    name: "",
    quotationNumber: "",
    planName: "",
    description: "",
    custId: "",
    amount: 0,
    requestType: "",
    isPaid: false,
    isSuccess: false,
    expiryDate: "",
    ProductName: "",
    sourceOfBusiness: "",
  });

  const isOneEnabled = process.env.REACT_APP_ONE_ENABLED === 'true';

  const paymentMethods = [
    { name: "Debit Card", name_ar: "بطاقة الخصم", icon: benefitlogo },
    { name: "Credit Card", name_ar: "بطاقة إئتمان", icon: Creditlogo },
    { name: "Apple Pay", name_ar: "بطاقة إئتمان", icon: Apple },
    ...(isOneEnabled ? [{ name: "One", name_ar: "بطاقة إئتمان", icon: OneAppIcon }] : []),
  ];

  // Parse the query string
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id"); // Get the 'id' parameter
  const MethodSelected = async (selectedMethod) => {
    if (selectedMethod == "Credit Card") {
      setIsApplePaySelected(false);
      setCreditCard(true);
    } else if (selectedMethod == "Debit Card") {
      var benefitRes = await CreateBenefitCharge();
      var link = benefitRes["transaction"]["url"];
      //setLoading(false);
      window.location.href = link;
      //setLoading(false);
    } else if (selectedMethod == "Apple Pay") {
      setCreditCard(false);
      setIsApplePaySelected(true);
    } else if (selectedMethod == "One") {
      var initiatedOneApp = await InitiateOneApp(id, setLoading, setOneAppSelected);

      // Check if the response indicates an error or success based on success flag
      if (!initiatedOneApp || initiatedOneApp.success === false) {
        // Error occurred or no response - show error view
        setOneAppError(true);
        setOneAppSuccess(false);
        setOneAppSelected(false);
      } else if (initiatedOneApp.success === true) {
        // Success - show success view
        setOneAppSuccess(true);
        setOneAppError(false);
        setOneAppSelected(false);
      } else {
        // Fallback - show error view
        setOneAppError(true);
        setOneAppSuccess(false);
        setOneAppSelected(false);
      }
    }
  };

  const cancelSelectionCredit = () => {
    setCreditCard(false);
  };

  useEffect(() => {
    const abortController = new AbortController();

    if (isApplePayAvailable()) {
      setIsApplePayVisible(true);
    }
    console.log("Apple Pay is: " + isApplePayVisible);
    console.log("Token: " + id);
    fetchRequest(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, []);

  const GetDocs = async (quote, signal) => {
    const url = process.env.REACT_APP_WEB_API + "policy/ViewIssuedQuoteDocs";
    const data = {
      quote: quote,
    };

    try {
      setIsQuoteLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: signal,
      });

      if (!response.ok) {
        setIsQuoteLoading(false);
        throw new Error("Failed to fetch payment requests");
      }
      setIsQuoteLoading(false);
      const result = await response.json();
      const firstFile =
        result
          ?.filter((r) => String(r.ID).toUpperCase() === "MOTOR_QUOTATION")
          ?.sort((a, b) => {
            const [ad, am, ay] = (a.Date || "").split("/").map(Number); // dd/MM/yyyy
            const [bd, bm, by] = (b.Date || "").split("/").map(Number);
            return new Date(by, bm - 1, bd) - new Date(ay, am - 1, ad); // newest first
          })?.[0]?.File ?? null;
      setFile(firstFile);
      const filteredDocs = result.filter((doc) => !doc.url);
      setDocuments(filteredDocs);
      setLoading(false);
      return result;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('ViewIssuedQuoteDocs request was cancelled');
        return;
      }
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };
  const fetchRequest = async (signal) => {
    const url = process.env.REACT_APP_PAYMENT_API + "Requests/GetCustomer";
    const data = {
      Token: id,
    };

    try {
      setIsApplePayLoading(true);
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: signal,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }
      const result = await response.json();
      setPaymentData((prevData) => ({
        ...prevData, // keep previous values
        name:
          result.paymentRequest.customersPayments.firstName +
          " " +
          result.paymentRequest.customersPayments.lastName,
        quotationNumber: result.paymentRequest.quoteNumber,
        planName: result.paymentRequest.productName,
        description: result.paymentRequest.payment_desc,
        custId:
          result.paymentRequest.requestType == "ForRecurring" ||
          result.paymentRequest.requestType == "ActivePolicyRecurring"
            ? result.paymentRequest.customersPayments.tapLifeCustId
            : result.paymentRequest.customersPayments.tapCustId,
        amount: result.paymentRequest.amount,
        requestType: result.paymentRequest.requestType,
        isPaid: result.paymentRequest.isPaid,
        isSuccess: result.paymentRequest.isSuccess,
        expiryDate: result.paymentRequest.expiryDate,
        ProductName: result.paymentRequest.productName,
        sourceOfBusiness: result.sourceOfBusiness
      }));
      console.log("sourceOfBusiness:", result.sourceOfBusiness);
      setLoading(false);
      setIsApplePayLoading(false);
      if (
        result.paymentRequest.requestType == "Policy" &&
        result.paymentRequest.productName != ""
      ) {
        GetDocs(result.paymentRequest.quoteNumber, signal);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('GetCustomer request was cancelled');
        return;
      }
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const CreateBenefitCharge = async () => {
    const url =
      process.env.REACT_APP_PAYMENT_API + "Payment/CreateBenefitCharge";
    const data = {
      amount: paymentData.amount,
      Quote: paymentData.quotationNumber,
      transaction: paymentData.quotationNumber,
      CustomerId: paymentData.custId,
      RedirectLink:
        paymentData.requestType == "General Payment"
          ? process.env.REACT_APP_SB_HUB +
            "invoice?quote=" +
            paymentData.quotationNumber
          : process.env.REACT_APP_SB_HUB +
            "policy-documents?policy=" +
            paymentData.quotationNumber,
      WebHookLink:
        paymentData.requestType == "deductible"
          ? process.env.REACT_APP_PAYMENT_API + "Payment/ClaimPaymentWebHook"
          : paymentData.requestType == "depreciation"
          ? process.env.REACT_APP_PAYMENT_API + "Payment/ClaimPaymentWebHook"
          : process.env.REACT_APP_PAYMENT_API + "Payment/PaymentStatus",
      encryptedToken: id,
      PaymentType: paymentData.requestType,
      ProductName: paymentData.ProductName,
    };

    try {
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      return result;
    } catch (error) {
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const CreateApplePayCharge = async (token) => {
    const url =
      process.env.REACT_APP_PAYMENT_API + "Payment/CreateChargeApplePay";
    const data = {
      Token: token,
      amount: paymentData.amount,
      Quote: paymentData.quotationNumber,
      transaction: paymentData.quotationNumber,
      CustomerId: paymentData.custId,
      RedirectLink:
        paymentData.requestType == "General Payment"
          ? process.env.REACT_APP_SB_HUB +
            "invoice?quote=" +
            paymentData.quotationNumber
          : process.env.REACT_APP_SB_HUB +
            "policy-documents?policy=" +
            paymentData.quotationNumber,
      WebHookLink:
        paymentData.requestType == "deductible"
          ? process.env.REACT_APP_PAYMENT_API + "Payment/ClaimPaymentWebHook"
          : paymentData.requestType == "depreciation"
          ? process.env.REACT_APP_PAYMENT_API + "Payment/ClaimPaymentWebHook"
          : process.env.REACT_APP_PAYMENT_API + "Payment/PaymentStatus",
      encryptedToken: id,
      PaymentType: paymentData.requestType,
      ProductName: paymentData.ProductName,
    };

    try {
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return errorDetails;
      }

      const result = await response.json();

      return result;
    } catch (error) {
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  // SDK
  const SaveApplePayPayment = async (json) => {
    const url =
      process.env.REACT_APP_PAYMENT_API + "Payment/SaveApplePayPayment";
    const data = {
      Json: json,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      return result;
    } catch (error) {
      console.error("Error fetching payment requests:", error);
    }
  };

  const DecryptToken = async (token) => {
    const url = process.env.REACT_APP_PAYMENT_API + "Payment/DecryptToken";
    const data = {
      token: token,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      return result;
    } catch (error) {
      console.error("Error fetching payment requests:", error);
    }
  };

  const wrapperRef = useRef(null);
  const loadingRef = useRef(null);
  const handleGoBackFromError = () => {
    setOneAppError(false);
    setOneAppSuccess(false);
    setOneAppSelected(false);
  };

  return (
    <div className="flex justify-center items-center ">
      {id == null ? (
        <div className="flex flex-col w-[500px] max-w-[100%] mx-auto mt-20 max767:p-5">
          <img
            src={fail}
            alt="Verification Failed"
            className="text-center w-[96px] h-[96px]"
          />
          <p className="mt-5 flex">
            <b className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] ">
              404 - Page Not Found
            </b>
          </p>
          <p className="text-[#1A2024] text-base not-italic font-normal leading-6 tracking-[-0.16px] mb-4">
            We can't seem to find the page you're looking for
          </p>
        </div>
      ) : isOneAppSuccess ? (
        <div className="p-12 w-[48%] mt-[7%] mx-auto bg-[#F6F8F9] rounded-[26px] max767:pt-8 max767:mt-0 max767:p-5 max767:w-[100%] max767:rounded-none ipad:w-[95%] ipad:mt-[14%]">
          {/* Header with logos */}
          <div className="flex justify-start items-center gap-4 mb-8">
            <img src={logo} alt="Solidarity Logo" className="h-12" />
            <div className="h-10 w-px bg-gray-300"></div>
            <img src={OneAppIcon} alt="One App Logo" className="h-12" />
          </div>

          {/* Success Message */}
          <div className="mb-6  p-6 bg-white rounded-lg border border-gray-200">
            <div className="flex items-start gap-4">

              <div className="flex-1">
                <svg width="312" height="32" viewBox="0 0 312 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_17448_26569)">
                <path d="M12 6C6.48 6 2 10.48 2 16C2 21.52 6.48 26 12 26C17.52 26 22 21.52 22 16C22 10.48 17.52 6 12 6ZM10 21L5 16L6.41 14.59L10 18.17L17.59 10.58L19 12L10 21Z" fill="#119C2B"/>
                </g>
                <path d="M42.7812 21.5977L47.3281 25.207L45.2656 27L40.7891 23.4141L42.7812 21.5977ZM47.4102 15.0352V15.9141C47.4102 17.2031 47.2383 18.3633 46.8945 19.3945C46.5508 20.418 46.0586 21.2891 45.418 22.0078C44.7852 22.7266 44.0312 23.2773 43.1562 23.6602C42.2812 24.043 41.3125 24.2344 40.25 24.2344C39.1953 24.2344 38.2266 24.043 37.3438 23.6602C36.4688 23.2773 35.7109 22.7266 35.0703 22.0078C34.4297 21.2891 33.9336 20.418 33.582 19.3945C33.2305 18.3633 33.0547 17.2031 33.0547 15.9141V15.0352C33.0547 13.7383 33.2266 12.5781 33.5703 11.5547C33.9219 10.5312 34.4141 9.66016 35.0469 8.94141C35.6875 8.21484 36.4453 7.66016 37.3203 7.27734C38.2031 6.89453 39.1719 6.70312 40.2266 6.70312C41.2891 6.70312 42.2578 6.89453 43.1328 7.27734C44.0156 7.66016 44.7734 8.21484 45.4062 8.94141C46.0469 9.66016 46.5391 10.5312 46.8828 11.5547C47.2344 12.5781 47.4102 13.7383 47.4102 15.0352ZM44.1523 15.9141V15.0117C44.1523 14.082 44.0664 13.2656 43.8945 12.5625C43.7227 11.8516 43.4648 11.2539 43.1211 10.7695C42.7852 10.2852 42.375 9.92188 41.8906 9.67969C41.4062 9.42969 40.8516 9.30469 40.2266 9.30469C39.6094 9.30469 39.0586 9.42969 38.5742 9.67969C38.0898 9.92188 37.6797 10.2852 37.3438 10.7695C37.0078 11.2539 36.75 11.8516 36.5703 12.5625C36.3984 13.2656 36.3125 14.082 36.3125 15.0117V15.9141C36.3125 16.8359 36.3984 17.6523 36.5703 18.3633C36.75 19.0742 37.0078 19.6758 37.3438 20.168C37.6875 20.6523 38.1016 21.0195 38.5859 21.2695C39.0781 21.5195 39.6328 21.6445 40.25 21.6445C40.875 21.6445 41.4297 21.5195 41.9141 21.2695C42.3984 21.0195 42.8047 20.6523 43.1328 20.168C43.4688 19.6758 43.7227 19.0742 43.8945 18.3633C44.0664 17.6523 44.1523 16.8359 44.1523 15.9141ZM57.2483 20.9883V11.3203H60.3655V24H57.4358L57.2483 20.9883ZM57.6467 18.3633L58.6077 18.3398C58.6077 19.1914 58.5139 19.9766 58.3264 20.6953C58.1389 21.4141 57.8459 22.0391 57.4475 22.5703C57.0569 23.0938 56.5608 23.5039 55.9592 23.8008C55.3577 24.0898 54.6467 24.2344 53.8264 24.2344C53.2014 24.2344 52.6311 24.1484 52.1155 23.9766C51.5998 23.7969 51.1545 23.5195 50.7795 23.1445C50.4123 22.7617 50.1272 22.2734 49.9241 21.6797C49.7209 21.0781 49.6194 20.3555 49.6194 19.5117V11.3203H52.7131V19.5352C52.7131 19.957 52.76 20.3086 52.8538 20.5898C52.9553 20.8711 53.092 21.1016 53.2639 21.2812C53.4436 21.4531 53.6506 21.5781 53.885 21.6562C54.1272 21.7266 54.385 21.7617 54.6584 21.7617C55.4084 21.7617 55.9983 21.6133 56.428 21.3164C56.8655 21.0117 57.178 20.6055 57.3655 20.0977C57.553 19.582 57.6467 19.0039 57.6467 18.3633ZM62.3169 17.7891V17.543C62.3169 16.6133 62.4497 15.7578 62.7153 14.9766C62.9809 14.1875 63.3677 13.5039 63.8755 12.9258C64.3833 12.3477 65.0044 11.8984 65.7388 11.5781C66.4731 11.25 67.3091 11.0859 68.2466 11.0859C69.1997 11.0859 70.0434 11.25 70.7778 11.5781C71.52 11.8984 72.145 12.3477 72.6528 12.9258C73.1606 13.5039 73.5473 14.1875 73.813 14.9766C74.0786 15.7578 74.2114 16.6133 74.2114 17.543V17.7891C74.2114 18.7109 74.0786 19.5664 73.813 20.3555C73.5473 21.1367 73.1606 21.8203 72.6528 22.4062C72.145 22.9844 71.5239 23.4336 70.7895 23.7539C70.0552 24.0742 69.2153 24.2344 68.27 24.2344C67.3325 24.2344 66.4927 24.0742 65.7505 23.7539C65.0083 23.4336 64.3833 22.9844 63.8755 22.4062C63.3677 21.8203 62.9809 21.1367 62.7153 20.3555C62.4497 19.5664 62.3169 18.7109 62.3169 17.7891ZM65.4106 17.543V17.7891C65.4106 18.3438 65.4653 18.8633 65.5747 19.3477C65.6841 19.832 65.852 20.2578 66.0786 20.625C66.3052 20.9922 66.5981 21.2812 66.9575 21.4922C67.3247 21.6953 67.7622 21.7969 68.27 21.7969C68.77 21.7969 69.1997 21.6953 69.5591 21.4922C69.9184 21.2812 70.2114 20.9922 70.438 20.625C70.6723 20.2578 70.8442 19.832 70.9536 19.3477C71.063 18.8633 71.1177 18.3438 71.1177 17.7891V17.543C71.1177 16.9961 71.063 16.4844 70.9536 16.0078C70.8442 15.5234 70.6723 15.0977 70.438 14.7305C70.2114 14.3555 69.9145 14.0625 69.5473 13.8516C69.188 13.6328 68.7544 13.5234 68.2466 13.5234C67.7466 13.5234 67.3169 13.6328 66.9575 13.8516C66.5981 14.0625 66.3052 14.3555 66.0786 14.7305C65.852 15.0977 65.6841 15.5234 65.5747 16.0078C65.4653 16.4844 65.4106 16.9961 65.4106 17.543ZM82.2214 11.3203V13.5469H74.9558V11.3203H82.2214ZM76.9011 8.20312H80.0066V20.3438C80.0066 20.7188 80.0573 21.0078 80.1589 21.2109C80.2605 21.4141 80.4128 21.5508 80.6159 21.6211C80.8191 21.6914 81.0612 21.7266 81.3425 21.7266C81.5456 21.7266 81.7331 21.7148 81.905 21.6914C82.0769 21.668 82.2214 21.6445 82.3386 21.6211L82.3503 23.9414C82.0925 24.0273 81.7995 24.0977 81.4714 24.1523C81.1511 24.207 80.7878 24.2344 80.3816 24.2344C79.6862 24.2344 79.0769 24.1172 78.5534 23.8828C78.03 23.6406 77.6237 23.2539 77.3347 22.7227C77.0456 22.1836 76.9011 21.4727 76.9011 20.5898V8.20312ZM91.0283 21.3047V15.457C91.0283 15.0273 90.9541 14.6562 90.8056 14.3438C90.6572 14.0312 90.4306 13.7891 90.1259 13.6172C89.8213 13.4453 89.4345 13.3594 88.9658 13.3594C88.5517 13.3594 88.1884 13.4297 87.8759 13.5703C87.5713 13.7109 87.3369 13.9102 87.1728 14.168C87.0088 14.418 86.9267 14.707 86.9267 15.0352H83.8213C83.8213 14.5117 83.9463 14.0156 84.1963 13.5469C84.4463 13.0703 84.8017 12.6484 85.2627 12.2812C85.7314 11.9062 86.29 11.6133 86.9384 11.4023C87.5947 11.1914 88.3291 11.0859 89.1416 11.0859C90.1025 11.0859 90.958 11.25 91.708 11.5781C92.4658 11.8984 93.0595 12.3828 93.4892 13.0312C93.9267 13.6797 94.1455 14.4961 94.1455 15.4805V21.0117C94.1455 21.6445 94.1845 22.1875 94.2627 22.6406C94.3486 23.0859 94.4736 23.4727 94.6377 23.8008V24H91.4853C91.3369 23.6797 91.2236 23.2734 91.1455 22.7812C91.0673 22.2812 91.0283 21.7891 91.0283 21.3047ZM91.4619 16.2773L91.4853 18.1172H89.5283C89.0439 18.1172 88.6181 18.168 88.2509 18.2695C87.8838 18.3633 87.583 18.5039 87.3486 18.6914C87.1142 18.8711 86.9384 19.0898 86.8213 19.3477C86.7041 19.5977 86.6455 19.8828 86.6455 20.2031C86.6455 20.5156 86.7158 20.7969 86.8564 21.0469C87.0048 21.2969 87.2158 21.4961 87.4892 21.6445C87.7705 21.7852 88.0986 21.8555 88.4736 21.8555C89.0205 21.8555 89.497 21.7461 89.9033 21.5273C90.3095 21.3008 90.6259 21.0273 90.8525 20.707C91.0791 20.3867 91.2002 20.082 91.2158 19.793L92.1064 21.1289C91.997 21.4492 91.833 21.7891 91.6142 22.1484C91.3955 22.5078 91.1142 22.8438 90.7705 23.1562C90.4267 23.4688 90.0127 23.7266 89.5283 23.9297C89.0439 24.1328 88.4814 24.2344 87.8408 24.2344C87.0205 24.2344 86.2861 24.0703 85.6377 23.7422C84.9892 23.4141 84.4775 22.9648 84.1025 22.3945C83.7275 21.8242 83.54 21.1758 83.54 20.4492C83.54 19.7773 83.665 19.1836 83.915 18.668C84.165 18.1523 84.5361 17.7188 85.0283 17.3672C85.5205 17.0078 86.1298 16.7383 86.8564 16.5586C87.5908 16.3711 88.4306 16.2773 89.3759 16.2773H91.4619ZM102.695 11.3203V13.5469H95.4289V11.3203H102.695ZM97.3742 8.20312H100.48V20.3438C100.48 20.7188 100.53 21.0078 100.632 21.2109C100.734 21.4141 100.886 21.5508 101.089 21.6211C101.292 21.6914 101.534 21.7266 101.816 21.7266C102.019 21.7266 102.206 21.7148 102.378 21.6914C102.55 21.668 102.695 21.6445 102.812 21.6211L102.823 23.9414C102.566 24.0273 102.273 24.0977 101.945 24.1523C101.624 24.207 101.261 24.2344 100.855 24.2344C100.159 24.2344 99.55 24.1172 99.0266 23.8828C98.5031 23.6406 98.0969 23.2539 97.8078 22.7227C97.5187 22.1836 97.3742 21.4727 97.3742 20.5898V8.20312ZM107.798 11.3203V24H104.693V11.3203H107.798ZM104.482 8.00391C104.482 7.54297 104.638 7.16016 104.951 6.85547C105.271 6.55078 105.701 6.39844 106.24 6.39844C106.779 6.39844 107.205 6.55078 107.517 6.85547C107.837 7.16016 107.997 7.54297 107.997 8.00391C107.997 8.45703 107.837 8.83594 107.517 9.14062C107.205 9.44531 106.779 9.59766 106.24 9.59766C105.701 9.59766 105.271 9.44531 104.951 9.14062C104.638 8.83594 104.482 8.45703 104.482 8.00391ZM109.961 17.7891V17.543C109.961 16.6133 110.093 15.7578 110.359 14.9766C110.625 14.1875 111.011 13.5039 111.519 12.9258C112.027 12.3477 112.648 11.8984 113.382 11.5781C114.117 11.25 114.953 11.0859 115.89 11.0859C116.843 11.0859 117.687 11.25 118.422 11.5781C119.164 11.8984 119.789 12.3477 120.297 12.9258C120.804 13.5039 121.191 14.1875 121.457 14.9766C121.722 15.7578 121.855 16.6133 121.855 17.543V17.7891C121.855 18.7109 121.722 19.5664 121.457 20.3555C121.191 21.1367 120.804 21.8203 120.297 22.4062C119.789 22.9844 119.168 23.4336 118.433 23.7539C117.699 24.0742 116.859 24.2344 115.914 24.2344C114.976 24.2344 114.136 24.0742 113.394 23.7539C112.652 23.4336 112.027 22.9844 111.519 22.4062C111.011 21.8203 110.625 21.1367 110.359 20.3555C110.093 19.5664 109.961 18.7109 109.961 17.7891ZM113.054 17.543V17.7891C113.054 18.3438 113.109 18.8633 113.218 19.3477C113.328 19.832 113.496 20.2578 113.722 20.625C113.949 20.9922 114.242 21.2812 114.601 21.4922C114.968 21.6953 115.406 21.7969 115.914 21.7969C116.414 21.7969 116.843 21.6953 117.203 21.4922C117.562 21.2812 117.855 20.9922 118.082 20.625C118.316 20.2578 118.488 19.832 118.597 19.3477C118.707 18.8633 118.761 18.3438 118.761 17.7891V17.543C118.761 16.9961 118.707 16.4844 118.597 16.0078C118.488 15.5234 118.316 15.0977 118.082 14.7305C117.855 14.3555 117.558 14.0625 117.191 13.8516C116.832 13.6328 116.398 13.5234 115.89 13.5234C115.39 13.5234 114.961 13.6328 114.601 13.8516C114.242 14.0625 113.949 14.3555 113.722 14.7305C113.496 15.0977 113.328 15.5234 113.218 16.0078C113.109 16.4844 113.054 16.9961 113.054 17.543ZM126.9 14.0273V24H123.807V11.3203H126.713L126.9 14.0273ZM126.408 17.2031H125.494C125.502 16.2812 125.627 15.4453 125.869 14.6953C126.111 13.9453 126.451 13.3008 126.889 12.7617C127.334 12.2227 127.861 11.8086 128.471 11.5195C129.08 11.2305 129.76 11.0859 130.51 11.0859C131.119 11.0859 131.67 11.1719 132.162 11.3438C132.654 11.5156 133.076 11.7891 133.428 12.1641C133.787 12.5391 134.06 13.0312 134.248 13.6406C134.443 14.2422 134.541 14.9844 134.541 15.8672V24H131.424V15.8438C131.424 15.2656 131.338 14.8086 131.166 14.4727C131.002 14.1367 130.76 13.8984 130.439 13.7578C130.127 13.6172 129.74 13.5469 129.279 13.5469C128.803 13.5469 128.385 13.6445 128.025 13.8398C127.674 14.0273 127.377 14.2891 127.135 14.625C126.9 14.9609 126.721 15.3477 126.596 15.7852C126.471 16.2227 126.408 16.6953 126.408 17.2031ZM151.932 19.5703C151.932 19.2422 151.881 18.9492 151.78 18.6914C151.686 18.4258 151.51 18.1875 151.252 17.9766C151.002 17.7578 150.647 17.5469 150.186 17.3438C149.733 17.1328 149.147 16.9141 148.428 16.6875C147.631 16.4375 146.889 16.1562 146.202 15.8438C145.514 15.5312 144.909 15.168 144.385 14.7539C143.87 14.3398 143.467 13.8633 143.178 13.3242C142.889 12.7773 142.745 12.1445 142.745 11.4258C142.745 10.7227 142.893 10.082 143.19 9.50391C143.495 8.92578 143.924 8.42969 144.479 8.01562C145.034 7.59375 145.686 7.26953 146.436 7.04297C147.194 6.81641 148.03 6.70312 148.944 6.70312C150.209 6.70312 151.303 6.93359 152.225 7.39453C153.155 7.85547 153.873 8.48047 154.381 9.26953C154.889 10.0586 155.143 10.9453 155.143 11.9297H151.932C151.932 11.3984 151.819 10.9297 151.592 10.5234C151.373 10.1172 151.037 9.79688 150.584 9.5625C150.139 9.32812 149.577 9.21094 148.897 9.21094C148.241 9.21094 147.694 9.30859 147.256 9.50391C146.827 9.69922 146.502 9.96484 146.284 10.3008C146.073 10.6367 145.967 11.0117 145.967 11.4258C145.967 11.7383 146.041 12.0195 146.19 12.2695C146.338 12.5117 146.561 12.7422 146.858 12.9609C147.155 13.1719 147.522 13.3711 147.959 13.5586C148.405 13.7383 148.92 13.918 149.506 14.0977C150.444 14.3789 151.264 14.6914 151.967 15.0352C152.678 15.3789 153.268 15.7695 153.737 16.207C154.213 16.6445 154.569 17.1367 154.803 17.6836C155.045 18.2305 155.166 18.8516 155.166 19.5469C155.166 20.2812 155.022 20.9375 154.733 21.5156C154.444 22.0938 154.03 22.5859 153.491 22.9922C152.952 23.3984 152.303 23.707 151.545 23.918C150.795 24.1289 149.955 24.2344 149.026 24.2344C148.198 24.2344 147.377 24.125 146.565 23.9062C145.76 23.6797 145.03 23.3438 144.373 22.8984C143.717 22.4453 143.194 21.875 142.803 21.1875C142.412 20.4922 142.217 19.6797 142.217 18.75H145.452C145.452 19.2891 145.537 19.75 145.709 20.1328C145.889 20.5078 146.139 20.8164 146.459 21.0586C146.787 21.293 147.17 21.4648 147.608 21.5742C148.045 21.6836 148.518 21.7383 149.026 21.7383C149.682 21.7383 150.221 21.6484 150.643 21.4688C151.073 21.2812 151.393 21.0234 151.604 20.6953C151.823 20.3672 151.932 19.9922 151.932 19.5703ZM162.872 24.2344C161.911 24.2344 161.048 24.0781 160.282 23.7656C159.516 23.4531 158.864 23.0195 158.325 22.4648C157.794 21.9023 157.383 21.25 157.094 20.5078C156.813 19.7578 156.673 18.9531 156.673 18.0938V17.625C156.673 16.6484 156.813 15.7617 157.094 14.9648C157.376 14.1602 157.774 13.4688 158.29 12.8906C158.805 12.3125 159.423 11.8672 160.141 11.5547C160.86 11.2422 161.653 11.0859 162.52 11.0859C163.419 11.0859 164.212 11.2383 164.899 11.543C165.587 11.8398 166.161 12.2617 166.622 12.8086C167.083 13.3555 167.43 14.0117 167.665 14.7773C167.899 15.5352 168.016 16.375 168.016 17.2969V18.5977H158.079V16.4648H164.969V16.2305C164.954 15.7383 164.86 15.2891 164.688 14.8828C164.516 14.4688 164.251 14.1406 163.891 13.8984C163.532 13.6484 163.067 13.5234 162.497 13.5234C162.036 13.5234 161.633 13.625 161.29 13.8281C160.954 14.0234 160.673 14.3047 160.446 14.6719C160.227 15.0312 160.063 15.4609 159.954 15.9609C159.844 16.4609 159.79 17.0156 159.79 17.625V18.0938C159.79 18.625 159.86 19.1172 160.001 19.5703C160.149 20.0234 160.364 20.418 160.645 20.7539C160.934 21.082 161.278 21.3398 161.676 21.5273C162.083 21.707 162.544 21.7969 163.059 21.7969C163.708 21.7969 164.294 21.6719 164.817 21.4219C165.348 21.1641 165.809 20.7852 166.2 20.2852L167.758 21.9023C167.493 22.293 167.133 22.668 166.68 23.0273C166.235 23.3867 165.696 23.6797 165.063 23.9062C164.43 24.125 163.7 24.2344 162.872 24.2344ZM172.886 14.0273V24H169.792V11.3203H172.698L172.886 14.0273ZM172.393 17.2031H171.479C171.487 16.2812 171.612 15.4453 171.854 14.6953C172.097 13.9453 172.436 13.3008 172.874 12.7617C173.319 12.2227 173.847 11.8086 174.456 11.5195C175.065 11.2305 175.745 11.0859 176.495 11.0859C177.104 11.0859 177.655 11.1719 178.147 11.3438C178.64 11.5156 179.061 11.7891 179.413 12.1641C179.772 12.5391 180.046 13.0312 180.233 13.6406C180.429 14.2422 180.526 14.9844 180.526 15.8672V24H177.409V15.8438C177.409 15.2656 177.323 14.8086 177.151 14.4727C176.987 14.1367 176.745 13.8984 176.425 13.7578C176.112 13.6172 175.725 13.5469 175.265 13.5469C174.788 13.5469 174.37 13.6445 174.011 13.8398C173.659 14.0273 173.362 14.2891 173.12 14.625C172.886 14.9609 172.706 15.3477 172.581 15.7852C172.456 16.2227 172.393 16.6953 172.393 17.2031ZM189.017 11.3203V13.5469H181.751V11.3203H189.017ZM183.696 8.20312H186.802V20.3438C186.802 20.7188 186.853 21.0078 186.954 21.2109C187.056 21.4141 187.208 21.5508 187.411 21.6211C187.614 21.6914 187.857 21.7266 188.138 21.7266C188.341 21.7266 188.528 21.7148 188.7 21.6914C188.872 21.668 189.017 21.6445 189.134 21.6211L189.146 23.9414C188.888 24.0273 188.595 24.0977 188.267 24.1523C187.946 24.207 187.583 24.2344 187.177 24.2344C186.482 24.2344 185.872 24.1172 185.349 23.8828C184.825 23.6406 184.419 23.2539 184.13 22.7227C183.841 22.1836 183.696 21.4727 183.696 20.5898V8.20312ZM202.576 11.3203V13.5469H195.31V11.3203H202.576ZM197.255 8.20312H200.361V20.3438C200.361 20.7188 200.412 21.0078 200.513 21.2109C200.615 21.4141 200.767 21.5508 200.97 21.6211C201.173 21.6914 201.416 21.7266 201.697 21.7266C201.9 21.7266 202.087 21.7148 202.259 21.6914C202.431 21.668 202.576 21.6445 202.693 21.6211L202.705 23.9414C202.447 24.0273 202.154 24.0977 201.826 24.1523C201.505 24.207 201.142 24.2344 200.736 24.2344C200.041 24.2344 199.431 24.1172 198.908 23.8828C198.384 23.6406 197.978 23.2539 197.689 22.7227C197.4 22.1836 197.255 21.4727 197.255 20.5898V8.20312ZM203.543 17.7891V17.543C203.543 16.6133 203.676 15.7578 203.941 14.9766C204.207 14.1875 204.594 13.5039 205.101 12.9258C205.609 12.3477 206.23 11.8984 206.965 11.5781C207.699 11.25 208.535 11.0859 209.473 11.0859C210.426 11.0859 211.269 11.25 212.004 11.5781C212.746 11.8984 213.371 12.3477 213.879 12.9258C214.387 13.5039 214.773 14.1875 215.039 14.9766C215.305 15.7578 215.437 16.6133 215.437 17.543V17.7891C215.437 18.7109 215.305 19.5664 215.039 20.3555C214.773 21.1367 214.387 21.8203 213.879 22.4062C213.371 22.9844 212.75 23.4336 212.015 23.7539C211.281 24.0742 210.441 24.2344 209.496 24.2344C208.558 24.2344 207.719 24.0742 206.976 23.7539C206.234 23.4336 205.609 22.9844 205.101 22.4062C204.594 21.8203 204.207 21.1367 203.941 20.3555C203.676 19.5664 203.543 18.7109 203.543 17.7891ZM206.637 17.543V17.7891C206.637 18.3438 206.691 18.8633 206.801 19.3477C206.91 19.832 207.078 20.2578 207.305 20.625C207.531 20.9922 207.824 21.2812 208.183 21.4922C208.551 21.6953 208.988 21.7969 209.496 21.7969C209.996 21.7969 210.426 21.6953 210.785 21.4922C211.144 21.2812 211.437 20.9922 211.664 20.625C211.898 20.2578 212.07 19.832 212.18 19.3477C212.289 18.8633 212.344 18.3438 212.344 17.7891V17.543C212.344 16.9961 212.289 16.4844 212.18 16.0078C212.07 15.5234 211.898 15.0977 211.664 14.7305C211.437 14.3555 211.14 14.0625 210.773 13.8516C210.414 13.6328 209.98 13.5234 209.473 13.5234C208.973 13.5234 208.543 13.6328 208.183 13.8516C207.824 14.0625 207.531 14.3555 207.305 14.7305C207.078 15.0977 206.91 15.5234 206.801 16.0078C206.691 16.4844 206.637 16.9961 206.637 17.543ZM237.235 15.0352V15.9141C237.235 17.2031 237.063 18.3633 236.719 19.3945C236.375 20.418 235.887 21.2891 235.254 22.0078C234.621 22.7266 233.867 23.2773 232.992 23.6602C232.117 24.043 231.145 24.2344 230.075 24.2344C229.02 24.2344 228.051 24.043 227.168 23.6602C226.293 23.2773 225.535 22.7266 224.895 22.0078C224.254 21.2891 223.758 20.418 223.407 19.3945C223.055 18.3633 222.879 17.2031 222.879 15.9141V15.0352C222.879 13.7383 223.055 12.5781 223.407 11.5547C223.758 10.5312 224.25 9.66016 224.883 8.94141C225.516 8.21484 226.27 7.66016 227.145 7.27734C228.028 6.89453 228.996 6.70312 230.051 6.70312C231.121 6.70312 232.094 6.89453 232.969 7.27734C233.844 7.66016 234.598 8.21484 235.231 8.94141C235.871 9.66016 236.364 10.5312 236.707 11.5547C237.059 12.5781 237.235 13.7383 237.235 15.0352ZM233.977 15.9141V15.0117C233.977 14.082 233.891 13.2656 233.719 12.5625C233.547 11.8516 233.293 11.2539 232.957 10.7695C232.621 10.2852 232.207 9.92188 231.715 9.67969C231.223 9.42969 230.668 9.30469 230.051 9.30469C229.426 9.30469 228.871 9.42969 228.387 9.67969C227.91 9.92188 227.504 10.2852 227.168 10.7695C226.832 11.2539 226.575 11.8516 226.395 12.5625C226.223 13.2656 226.137 14.082 226.137 15.0117V15.9141C226.137 16.8359 226.223 17.6523 226.395 18.3633C226.575 19.0742 226.832 19.6758 227.168 20.168C227.512 20.6523 227.926 21.0195 228.41 21.2695C228.895 21.5195 229.45 21.6445 230.075 21.6445C230.7 21.6445 231.254 21.5195 231.739 21.2695C232.223 21.0195 232.629 20.6523 232.957 20.168C233.293 19.6758 233.547 19.0742 233.719 18.3633C233.891 17.6523 233.977 16.8359 233.977 15.9141ZM242.526 14.0273V24H239.432V11.3203H242.338L242.526 14.0273ZM242.034 17.2031H241.12C241.128 16.2812 241.253 15.4453 241.495 14.6953C241.737 13.9453 242.077 13.3008 242.514 12.7617C242.96 12.2227 243.487 11.8086 244.096 11.5195C244.706 11.2305 245.385 11.0859 246.135 11.0859C246.745 11.0859 247.295 11.1719 247.788 11.3438C248.28 11.5156 248.702 11.7891 249.053 12.1641C249.413 12.5391 249.686 13.0312 249.874 13.6406C250.069 14.2422 250.167 14.9844 250.167 15.8672V24H247.049V15.8438C247.049 15.2656 246.963 14.8086 246.792 14.4727C246.628 14.1367 246.385 13.8984 246.065 13.7578C245.753 13.6172 245.366 13.5469 244.905 13.5469C244.428 13.5469 244.01 13.6445 243.651 13.8398C243.299 14.0273 243.003 14.2891 242.76 14.625C242.526 14.9609 242.346 15.3477 242.221 15.7852C242.096 16.2227 242.034 16.6953 242.034 17.2031ZM258.352 24.2344C257.391 24.2344 256.528 24.0781 255.762 23.7656C254.997 23.4531 254.345 23.0195 253.805 22.4648C253.274 21.9023 252.864 21.25 252.575 20.5078C252.294 19.7578 252.153 18.9531 252.153 18.0938V17.625C252.153 16.6484 252.294 15.7617 252.575 14.9648C252.856 14.1602 253.255 13.4688 253.77 12.8906C254.286 12.3125 254.903 11.8672 255.622 11.5547C256.341 11.2422 257.134 11.0859 258.001 11.0859C258.899 11.0859 259.692 11.2383 260.38 11.543C261.067 11.8398 261.641 12.2617 262.102 12.8086C262.563 13.3555 262.911 14.0117 263.145 14.7773C263.38 15.5352 263.497 16.375 263.497 17.2969V18.5977H253.559V16.4648H260.45V16.2305C260.434 15.7383 260.341 15.2891 260.169 14.8828C259.997 14.4688 259.731 14.1406 259.372 13.8984C259.012 13.6484 258.548 13.5234 257.977 13.5234C257.516 13.5234 257.114 13.625 256.77 13.8281C256.434 14.0234 256.153 14.3047 255.927 14.6719C255.708 15.0312 255.544 15.4609 255.434 15.9609C255.325 16.4609 255.27 17.0156 255.27 17.625V18.0938C255.27 18.625 255.341 19.1172 255.481 19.5703C255.63 20.0234 255.845 20.418 256.126 20.7539C256.415 21.082 256.759 21.3398 257.157 21.5273C257.563 21.707 258.024 21.7969 258.54 21.7969C259.188 21.7969 259.774 21.6719 260.298 21.4219C260.829 21.1641 261.29 20.7852 261.68 20.2852L263.239 21.9023C262.973 22.293 262.614 22.668 262.161 23.0273C261.716 23.3867 261.177 23.6797 260.544 23.9062C259.911 24.125 259.18 24.2344 258.352 24.2344ZM278.087 9.52734L273.224 24H269.814L276.189 6.9375H278.368L278.087 9.52734ZM282.154 24L277.267 9.52734L276.974 6.9375H279.165L285.575 24H282.154ZM281.931 17.6602V20.2031H272.779V17.6602H281.931ZM289.648 13.7578V28.875H286.542V11.3203H289.414L289.648 13.7578ZM297.792 17.5312V17.7773C297.792 18.6992 297.683 19.5547 297.464 20.3438C297.253 21.125 296.941 21.8086 296.527 22.3945C296.113 22.9727 295.597 23.4258 294.98 23.7539C294.371 24.0742 293.667 24.2344 292.871 24.2344C292.089 24.2344 291.41 24.0859 290.832 23.7891C290.253 23.4844 289.765 23.0547 289.367 22.5C288.968 21.9453 288.648 21.3008 288.406 20.5664C288.171 19.8242 287.996 19.0156 287.878 18.1406V17.3555C287.996 16.4258 288.171 15.582 288.406 14.8242C288.648 14.0586 288.968 13.3984 289.367 12.8438C289.765 12.2812 290.25 11.8477 290.82 11.543C291.398 11.2383 292.074 11.0859 292.847 11.0859C293.652 11.0859 294.359 11.2383 294.968 11.543C295.585 11.8477 296.105 12.2852 296.527 12.8555C296.949 13.4258 297.265 14.1055 297.476 14.8945C297.687 15.6836 297.792 16.5625 297.792 17.5312ZM294.687 17.7773V17.5312C294.687 16.9688 294.636 16.4492 294.535 15.9727C294.433 15.4883 294.277 15.0664 294.066 14.707C293.855 14.3398 293.582 14.0547 293.246 13.8516C292.91 13.6484 292.503 13.5469 292.027 13.5469C291.55 13.5469 291.14 13.625 290.796 13.7812C290.453 13.9375 290.171 14.1602 289.953 14.4492C289.734 14.7383 289.562 15.082 289.437 15.4805C289.32 15.8711 289.242 16.3047 289.203 16.7812V18.7266C289.273 19.3047 289.41 19.8242 289.613 20.2852C289.816 20.7461 290.113 21.1133 290.503 21.3867C290.902 21.6602 291.417 21.7969 292.05 21.7969C292.527 21.7969 292.933 21.6914 293.269 21.4805C293.605 21.2695 293.878 20.9805 294.089 20.6133C294.3 20.2383 294.453 19.8086 294.546 19.3242C294.64 18.8398 294.687 18.3242 294.687 17.7773ZM302.908 13.7578V28.875H299.802V11.3203H302.674L302.908 13.7578ZM311.052 17.5312V17.7773C311.052 18.6992 310.943 19.5547 310.724 20.3438C310.513 21.125 310.201 21.8086 309.787 22.3945C309.373 22.9727 308.857 23.4258 308.24 23.7539C307.631 24.0742 306.927 24.2344 306.131 24.2344C305.349 24.2344 304.67 24.0859 304.092 23.7891C303.513 23.4844 303.025 23.0547 302.627 22.5C302.228 21.9453 301.908 21.3008 301.666 20.5664C301.431 19.8242 301.256 19.0156 301.138 18.1406V17.3555C301.256 16.4258 301.431 15.582 301.666 14.8242C301.908 14.0586 302.228 13.3984 302.627 12.8438C303.025 12.2812 303.51 11.8477 304.08 11.543C304.658 11.2383 305.334 11.0859 306.107 11.0859C306.912 11.0859 307.619 11.2383 308.228 11.543C308.845 11.8477 309.365 12.2852 309.787 12.8555C310.209 13.4258 310.525 14.1055 310.736 14.8945C310.947 15.6836 311.052 16.5625 311.052 17.5312ZM307.947 17.7773V17.5312C307.947 16.9688 307.896 16.4492 307.795 15.9727C307.693 15.4883 307.537 15.0664 307.326 14.707C307.115 14.3398 306.842 14.0547 306.506 13.8516C306.17 13.6484 305.763 13.5469 305.287 13.5469C304.81 13.5469 304.4 13.625 304.056 13.7812C303.713 13.9375 303.431 14.1602 303.213 14.4492C302.994 14.7383 302.822 15.082 302.697 15.4805C302.58 15.8711 302.502 16.3047 302.463 16.7812V18.7266C302.533 19.3047 302.67 19.8242 302.873 20.2852C303.076 20.7461 303.373 21.1133 303.763 21.3867C304.162 21.6602 304.677 21.7969 305.31 21.7969C305.787 21.7969 306.193 21.6914 306.529 21.4805C306.865 21.2695 307.138 20.9805 307.349 20.6133C307.56 20.2383 307.713 19.8086 307.806 19.3242C307.9 18.8398 307.947 18.3242 307.947 17.7773Z" fill="#119C2B"/>
                <defs>
                <clipPath id="clip0_17448_26569">
                <rect width="24" height="24" fill="white" transform="translate(0 4)"/>
                </clipPath>
                </defs>
                </svg>


                <p className="text-[#1A2024] text-base leading-relaxed max-w-2xl mt-2">
                  We’ve successfully sent your insurance quotation to One App. Open the One App on your phone to complete and finalize your payment. Once done, you’ll receive an SMS with your policy documents. </p>
              </div>
            </div>

            {/* Download Section */}
          <div className="my-6">
            <h3 className="text-xs font-bold text-[#1A2024] mb-3 uppercase tracking-wider">
              DOWNLOAD ONE APP
            </h3>
            <div className="flex gap-3 flex-wrap">
              <a
                href="https://apps.apple.com/bh/app/one-marketplace/id6737277998"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={appleLogo}
                  alt="Download on the App Store"
                  className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=bh.one.app&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={googleLogo}
                  alt="Get it on Google Play"
                  className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
            </div>
          </div>
          </div>





          {/* Footer */}
          <footer className="mt-8">
            <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%] mb-1">
              Solidarity Bahrain is a Subsidiary of Solidarity Group Holding
            </p>
            <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%]">
              Licensed and regulated by the Central Bank of Bahrain as a locally incorporated Takaful Firm – Category four
            </p>
          </footer>
        </div>
      ) : isOneAppError ? (
        <div className="p-12 w-[48%] mt-[7%] mx-auto bg-[#F6F8F9] rounded-[26px] max767:pt-8 max767:mt-0 max767:p-5 max767:w-[100%] max767:rounded-none ipad:w-[95%] ipad:mt-[14%]">
          {/* Header with logos */}
          <div className="flex justify-start items-center gap-4 mb-8">
            <img src={logo} alt="Solidarity Logo" className="h-12" />
            <div className="h-10 w-px bg-gray-300"></div>
            <img src={OneAppIcon} alt="One App Logo" className="h-12" />
          </div>

          {/* Error Message */}
          <div className="mb-6  p-6 bg-white rounded-lg border border-gray-200">
            <div className="flex items-start gap-4">
            
              <div className="flex-1">
                <svg width="275" height="32" viewBox="0 0 275 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_17448_26621)">
                <path d="M12 6C6.48 6 2 10.48 2 16C2 21.52 6.48 26 12 26C17.52 26 22 21.52 22 16C22 10.48 17.52 6 12 6ZM16 17H8C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17Z" fill="#CC0905"/>
                </g>
                <path d="M42.5586 19.5703C42.5586 19.2422 42.5078 18.9492 42.4062 18.6914C42.3125 18.4258 42.1367 18.1875 41.8789 17.9766C41.6289 17.7578 41.2734 17.5469 40.8125 17.3438C40.3594 17.1328 39.7734 16.9141 39.0547 16.6875C38.2578 16.4375 37.5156 16.1562 36.8281 15.8438C36.1406 15.5312 35.5352 15.168 35.0117 14.7539C34.4961 14.3398 34.0938 13.8633 33.8047 13.3242C33.5156 12.7773 33.3711 12.1445 33.3711 11.4258C33.3711 10.7227 33.5195 10.082 33.8164 9.50391C34.1211 8.92578 34.5508 8.42969 35.1055 8.01562C35.6602 7.59375 36.3125 7.26953 37.0625 7.04297C37.8203 6.81641 38.6562 6.70312 39.5703 6.70312C40.8359 6.70312 41.9297 6.93359 42.8516 7.39453C43.7812 7.85547 44.5 8.48047 45.0078 9.26953C45.5156 10.0586 45.7695 10.9453 45.7695 11.9297H42.5586C42.5586 11.3984 42.4453 10.9297 42.2188 10.5234C42 10.1172 41.6641 9.79688 41.2109 9.5625C40.7656 9.32812 40.2031 9.21094 39.5234 9.21094C38.8672 9.21094 38.3203 9.30859 37.8828 9.50391C37.4531 9.69922 37.1289 9.96484 36.9102 10.3008C36.6992 10.6367 36.5938 11.0117 36.5938 11.4258C36.5938 11.7383 36.668 12.0195 36.8164 12.2695C36.9648 12.5117 37.1875 12.7422 37.4844 12.9609C37.7812 13.1719 38.1484 13.3711 38.5859 13.5586C39.0312 13.7383 39.5469 13.918 40.1328 14.0977C41.0703 14.3789 41.8906 14.6914 42.5938 15.0352C43.3047 15.3789 43.8945 15.7695 44.3633 16.207C44.8398 16.6445 45.1953 17.1367 45.4297 17.6836C45.6719 18.2305 45.793 18.8516 45.793 19.5469C45.793 20.2812 45.6484 20.9375 45.3594 21.5156C45.0703 22.0938 44.6562 22.5859 44.1172 22.9922C43.5781 23.3984 42.9297 23.707 42.1719 23.918C41.4219 24.1289 40.582 24.2344 39.6523 24.2344C38.8242 24.2344 38.0039 24.125 37.1914 23.9062C36.3867 23.6797 35.6562 23.3438 35 22.8984C34.3438 22.4453 33.8203 21.875 33.4297 21.1875C33.0391 20.4922 32.8438 19.6797 32.8438 18.75H36.0781C36.0781 19.2891 36.1641 19.75 36.3359 20.1328C36.5156 20.5078 36.7656 20.8164 37.0859 21.0586C37.4141 21.293 37.7969 21.4648 38.2344 21.5742C38.6719 21.6836 39.1445 21.7383 39.6523 21.7383C40.3086 21.7383 40.8477 21.6484 41.2695 21.4688C41.6992 21.2812 42.0195 21.0234 42.2305 20.6953C42.4492 20.3672 42.5586 19.9922 42.5586 19.5703ZM47.2522 17.7891V17.543C47.2522 16.6133 47.385 15.7578 47.6506 14.9766C47.9163 14.1875 48.303 13.5039 48.8108 12.9258C49.3186 12.3477 49.9397 11.8984 50.6741 11.5781C51.4084 11.25 52.2444 11.0859 53.1819 11.0859C54.135 11.0859 54.9788 11.25 55.7131 11.5781C56.4553 11.8984 57.0803 12.3477 57.5881 12.9258C58.0959 13.5039 58.4827 14.1875 58.7483 14.9766C59.0139 15.7578 59.1467 16.6133 59.1467 17.543V17.7891C59.1467 18.7109 59.0139 19.5664 58.7483 20.3555C58.4827 21.1367 58.0959 21.8203 57.5881 22.4062C57.0803 22.9844 56.4592 23.4336 55.7248 23.7539C54.9905 24.0742 54.1506 24.2344 53.2053 24.2344C52.2678 24.2344 51.428 24.0742 50.6858 23.7539C49.9436 23.4336 49.3186 22.9844 48.8108 22.4062C48.303 21.8203 47.9163 21.1367 47.6506 20.3555C47.385 19.5664 47.2522 18.7109 47.2522 17.7891ZM50.3459 17.543V17.7891C50.3459 18.3438 50.4006 18.8633 50.51 19.3477C50.6194 19.832 50.7873 20.2578 51.0139 20.625C51.2405 20.9922 51.5334 21.2812 51.8928 21.4922C52.26 21.6953 52.6975 21.7969 53.2053 21.7969C53.7053 21.7969 54.135 21.6953 54.4944 21.4922C54.8538 21.2812 55.1467 20.9922 55.3733 20.625C55.6077 20.2578 55.7795 19.832 55.8889 19.3477C55.9983 18.8633 56.053 18.3438 56.053 17.7891V17.543C56.053 16.9961 55.9983 16.4844 55.8889 16.0078C55.7795 15.5234 55.6077 15.0977 55.3733 14.7305C55.1467 14.3555 54.8498 14.0625 54.4827 13.8516C54.1233 13.6328 53.6897 13.5234 53.1819 13.5234C52.6819 13.5234 52.2522 13.6328 51.8928 13.8516C51.5334 14.0625 51.2405 14.3555 51.0139 14.7305C50.7873 15.0977 50.6194 15.5234 50.51 16.0078C50.4006 16.4844 50.3459 16.9961 50.3459 17.543ZM64.2388 13.9219V24H61.145V11.3203H64.063L64.2388 13.9219ZM63.7817 17.2031H62.8325C62.8325 16.3203 62.938 15.5078 63.1489 14.7656C63.3677 14.0234 63.688 13.3789 64.1098 12.832C64.5317 12.2773 65.0513 11.8477 65.6684 11.543C66.2934 11.2383 67.0161 11.0859 67.8364 11.0859C68.4067 11.0859 68.9302 11.1719 69.4067 11.3438C69.8833 11.5078 70.2934 11.7695 70.6372 12.1289C70.9888 12.4805 71.2583 12.9414 71.4458 13.5117C71.6333 14.0742 71.727 14.75 71.727 15.5391V24H68.6333V15.8555C68.6333 15.2617 68.5473 14.7969 68.3755 14.4609C68.2114 14.125 67.9731 13.8906 67.6606 13.7578C67.3481 13.6172 66.9731 13.5469 66.5356 13.5469C66.0513 13.5469 65.6333 13.6445 65.2817 13.8398C64.938 14.0273 64.6528 14.2891 64.4263 14.625C64.2075 14.9609 64.0434 15.3477 63.9341 15.7852C63.8325 16.2227 63.7817 16.6953 63.7817 17.2031ZM71.4927 16.6289L70.2153 16.8633C70.2231 16.0664 70.3325 15.3203 70.5434 14.625C70.7544 13.9219 71.063 13.3086 71.4692 12.7852C71.8833 12.2539 72.395 11.8398 73.0044 11.543C73.6216 11.2383 74.3325 11.0859 75.1372 11.0859C75.7622 11.0859 76.3247 11.1758 76.8247 11.3555C77.3325 11.5273 77.7661 11.8047 78.1255 12.1875C78.4848 12.5625 78.7583 13.0508 78.9458 13.6523C79.1411 14.2539 79.2388 14.9883 79.2388 15.8555V24H76.1216V15.8438C76.1216 15.2266 76.0356 14.7539 75.8638 14.4258C75.6997 14.0977 75.4614 13.8711 75.1489 13.7461C74.8364 13.6133 74.4692 13.5469 74.0473 13.5469C73.6177 13.5469 73.2427 13.6289 72.9223 13.793C72.6098 13.9492 72.3442 14.168 72.1255 14.4492C71.9145 14.7305 71.7544 15.0586 71.645 15.4336C71.5434 15.8008 71.4927 16.1992 71.4927 16.6289ZM87.4714 24.2344C86.5105 24.2344 85.6472 24.0781 84.8816 23.7656C84.1159 23.4531 83.4636 23.0195 82.9245 22.4648C82.3933 21.9023 81.9831 21.25 81.6941 20.5078C81.4128 19.7578 81.2722 18.9531 81.2722 18.0938V17.625C81.2722 16.6484 81.4128 15.7617 81.6941 14.9648C81.9753 14.1602 82.3737 13.4688 82.8894 12.8906C83.405 12.3125 84.0222 11.8672 84.7409 11.5547C85.4597 11.2422 86.2527 11.0859 87.1198 11.0859C88.0183 11.0859 88.8112 11.2383 89.4987 11.543C90.1862 11.8398 90.7605 12.2617 91.2214 12.8086C91.6823 13.3555 92.03 14.0117 92.2644 14.7773C92.4987 15.5352 92.6159 16.375 92.6159 17.2969V18.5977H82.6784V16.4648H89.5691V16.2305C89.5534 15.7383 89.4597 15.2891 89.2878 14.8828C89.1159 14.4688 88.8503 14.1406 88.4909 13.8984C88.1316 13.6484 87.6667 13.5234 87.0964 13.5234C86.6355 13.5234 86.2331 13.625 85.8894 13.8281C85.5534 14.0234 85.2722 14.3047 85.0456 14.6719C84.8269 15.0312 84.6628 15.4609 84.5534 15.9609C84.4441 16.4609 84.3894 17.0156 84.3894 17.625V18.0938C84.3894 18.625 84.4597 19.1172 84.6003 19.5703C84.7487 20.0234 84.9636 20.418 85.2448 20.7539C85.5339 21.082 85.8777 21.3398 86.2761 21.5273C86.6823 21.707 87.1433 21.7969 87.6589 21.7969C88.3073 21.7969 88.8933 21.6719 89.4167 21.4219C89.948 21.1641 90.4089 20.7852 90.7995 20.2852L92.3581 21.9023C92.0925 22.293 91.7331 22.668 91.28 23.0273C90.8347 23.3867 90.2956 23.6797 89.6628 23.9062C89.03 24.125 88.2995 24.2344 87.4714 24.2344ZM100.45 11.3203V13.5469H93.1845V11.3203H100.45ZM95.1298 8.20312H98.2353V20.3438C98.2353 20.7188 98.2861 21.0078 98.3877 21.2109C98.4892 21.4141 98.6416 21.5508 98.8447 21.6211C99.0478 21.6914 99.29 21.7266 99.5713 21.7266C99.7744 21.7266 99.9619 21.7148 100.134 21.6914C100.306 21.668 100.45 21.6445 100.567 21.6211L100.579 23.9414C100.321 24.0273 100.028 24.0977 99.7002 24.1523C99.3798 24.207 99.0166 24.2344 98.6103 24.2344C97.915 24.2344 97.3056 24.1172 96.7822 23.8828C96.2588 23.6406 95.8525 23.2539 95.5634 22.7227C95.2744 22.1836 95.1298 21.4727 95.1298 20.5898V8.20312ZM105.308 6V24H102.202V6H105.308ZM104.816 17.2031H103.902C103.902 16.3203 104.019 15.5078 104.253 14.7656C104.488 14.0234 104.82 13.3789 105.249 12.832C105.679 12.2773 106.191 11.8477 106.784 11.543C107.386 11.2383 108.05 11.0859 108.777 11.0859C109.402 11.0859 109.968 11.1758 110.476 11.3555C110.991 11.5273 111.433 11.8047 111.8 12.1875C112.167 12.5703 112.448 13.0703 112.644 13.6875C112.847 14.2969 112.948 15.0391 112.948 15.9141V24H109.831V15.8906C109.831 15.3047 109.745 14.8438 109.573 14.5078C109.402 14.1641 109.155 13.918 108.835 13.7695C108.523 13.6211 108.136 13.5469 107.675 13.5469C107.175 13.5469 106.745 13.6445 106.386 13.8398C106.027 14.0273 105.73 14.2891 105.495 14.625C105.269 14.9609 105.097 15.3477 104.98 15.7852C104.87 16.2227 104.816 16.6953 104.816 17.2031ZM118.72 11.3203V24H115.615V11.3203H118.72ZM115.404 8.00391C115.404 7.54297 115.56 7.16016 115.872 6.85547C116.193 6.55078 116.622 6.39844 117.162 6.39844C117.701 6.39844 118.126 6.55078 118.439 6.85547C118.759 7.16016 118.919 7.54297 118.919 8.00391C118.919 8.45703 118.759 8.83594 118.439 9.14062C118.126 9.44531 117.701 9.59766 117.162 9.59766C116.622 9.59766 116.193 9.44531 115.872 9.14062C115.56 8.83594 115.404 8.45703 115.404 8.00391ZM124.468 14.0273V24H121.375V11.3203H124.281L124.468 14.0273ZM123.976 17.2031H123.062C123.07 16.2812 123.195 15.4453 123.437 14.6953C123.679 13.9453 124.019 13.3008 124.457 12.7617C124.902 12.2227 125.429 11.8086 126.039 11.5195C126.648 11.2305 127.328 11.0859 128.078 11.0859C128.687 11.0859 129.238 11.1719 129.73 11.3438C130.222 11.5156 130.644 11.7891 130.996 12.1641C131.355 12.5391 131.629 13.0312 131.816 13.6406C132.011 14.2422 132.109 14.9844 132.109 15.8672V24H128.992V15.8438C128.992 15.2656 128.906 14.8086 128.734 14.4727C128.57 14.1367 128.328 13.8984 128.007 13.7578C127.695 13.6172 127.308 13.5469 126.847 13.5469C126.371 13.5469 125.953 13.6445 125.593 13.8398C125.242 14.0273 124.945 14.2891 124.703 14.625C124.468 14.9609 124.289 15.3477 124.164 15.7852C124.039 16.2227 123.976 16.6953 123.976 17.2031ZM142.662 11.3203H145.475V23.6133C145.475 24.7617 145.225 25.7344 144.725 26.5312C144.232 27.3359 143.541 27.9453 142.65 28.3594C141.76 28.7812 140.725 28.9922 139.545 28.9922C139.037 28.9922 138.486 28.9219 137.893 28.7812C137.307 28.6406 136.74 28.418 136.193 28.1133C135.654 27.8164 135.205 27.4297 134.846 26.9531L136.24 25.125C136.662 25.6172 137.139 25.9883 137.67 26.2383C138.201 26.4961 138.775 26.625 139.393 26.625C140.018 26.625 140.549 26.5078 140.986 26.2734C141.432 26.0469 141.771 25.7109 142.006 25.2656C142.248 24.8281 142.369 24.2891 142.369 23.6484V14.2148L142.662 11.3203ZM134.096 17.8125V17.5664C134.096 16.5977 134.213 15.7188 134.447 14.9297C134.682 14.1328 135.018 13.4492 135.455 12.8789C135.9 12.3086 136.435 11.8672 137.06 11.5547C137.693 11.2422 138.404 11.0859 139.193 11.0859C140.029 11.0859 140.732 11.2383 141.303 11.543C141.881 11.8477 142.357 12.2812 142.732 12.8438C143.115 13.4062 143.412 14.0742 143.623 14.8477C143.842 15.6133 144.01 16.457 144.127 17.3789V18.0469C144.018 18.9453 143.842 19.7695 143.6 20.5195C143.365 21.2695 143.053 21.9258 142.662 22.4883C142.271 23.043 141.787 23.4727 141.209 23.7773C140.631 24.082 139.951 24.2344 139.17 24.2344C138.389 24.2344 137.685 24.0742 137.06 23.7539C136.435 23.4336 135.9 22.9844 135.455 22.4062C135.018 21.8281 134.682 21.1484 134.447 20.3672C134.213 19.5859 134.096 18.7344 134.096 17.8125ZM137.189 17.5664V17.8125C137.189 18.3594 137.244 18.8711 137.353 19.3477C137.463 19.8242 137.631 20.2461 137.857 20.6133C138.084 20.9727 138.369 21.2539 138.713 21.457C139.057 21.6602 139.467 21.7617 139.943 21.7617C140.584 21.7617 141.107 21.6289 141.514 21.3633C141.928 21.0898 142.24 20.7188 142.451 20.25C142.67 19.7734 142.81 19.2383 142.873 18.6445V16.8047C142.834 16.3359 142.748 15.9023 142.615 15.5039C142.49 15.1055 142.314 14.7617 142.088 14.4727C141.861 14.1836 141.572 13.957 141.221 13.793C140.869 13.6289 140.451 13.5469 139.967 13.5469C139.498 13.5469 139.088 13.6523 138.736 13.8633C138.385 14.0664 138.096 14.3516 137.869 14.7188C137.643 15.0859 137.471 15.5117 137.353 15.9961C137.244 16.4805 137.189 17.0039 137.189 17.5664ZM157.287 20.9531L160.065 11.3203H162.034L161.448 14.6484L158.647 24H156.948L157.287 20.9531ZM155.752 11.3203L157.838 20.9766L158.026 24H156.069L152.741 11.3203H155.752ZM164.612 20.8359L166.651 11.3203H169.651L166.346 24H164.389L164.612 20.8359ZM162.338 11.3203L165.092 20.8594L165.455 24H163.756L160.932 14.6484L160.358 11.3203H162.338ZM176.934 24.2344C175.973 24.2344 175.11 24.0781 174.344 23.7656C173.579 23.4531 172.926 23.0195 172.387 22.4648C171.856 21.9023 171.446 21.25 171.157 20.5078C170.876 19.7578 170.735 18.9531 170.735 18.0938V17.625C170.735 16.6484 170.876 15.7617 171.157 14.9648C171.438 14.1602 171.837 13.4688 172.352 12.8906C172.868 12.3125 173.485 11.8672 174.204 11.5547C174.923 11.2422 175.715 11.0859 176.583 11.0859C177.481 11.0859 178.274 11.2383 178.962 11.543C179.649 11.8398 180.223 12.2617 180.684 12.8086C181.145 13.3555 181.493 14.0117 181.727 14.7773C181.962 15.5352 182.079 16.375 182.079 17.2969V18.5977H172.141V16.4648H179.032V16.2305C179.016 15.7383 178.923 15.2891 178.751 14.8828C178.579 14.4688 178.313 14.1406 177.954 13.8984C177.594 13.6484 177.13 13.5234 176.559 13.5234C176.098 13.5234 175.696 13.625 175.352 13.8281C175.016 14.0234 174.735 14.3047 174.508 14.6719C174.29 15.0312 174.126 15.4609 174.016 15.9609C173.907 16.4609 173.852 17.0156 173.852 17.625V18.0938C173.852 18.625 173.923 19.1172 174.063 19.5703C174.212 20.0234 174.426 20.418 174.708 20.7539C174.997 21.082 175.34 21.3398 175.739 21.5273C176.145 21.707 176.606 21.7969 177.122 21.7969C177.77 21.7969 178.356 21.6719 178.88 21.4219C179.411 21.1641 179.872 20.7852 180.262 20.2852L181.821 21.9023C181.555 22.293 181.196 22.668 180.743 23.0273C180.298 23.3867 179.758 23.6797 179.126 23.9062C178.493 24.125 177.762 24.2344 176.934 24.2344ZM186.948 14.0273V24H183.854V11.3203H186.761L186.948 14.0273ZM186.456 17.2031H185.542C185.55 16.2812 185.675 15.4453 185.917 14.6953C186.159 13.9453 186.499 13.3008 186.936 12.7617C187.382 12.2227 187.909 11.8086 188.518 11.5195C189.128 11.2305 189.807 11.0859 190.557 11.0859C191.167 11.0859 191.718 11.1719 192.21 11.3438C192.702 11.5156 193.124 11.7891 193.475 12.1641C193.835 12.5391 194.108 13.0312 194.296 13.6406C194.491 14.2422 194.589 14.9844 194.589 15.8672V24H191.472V15.8438C191.472 15.2656 191.386 14.8086 191.214 14.4727C191.05 14.1367 190.807 13.8984 190.487 13.7578C190.175 13.6172 189.788 13.5469 189.327 13.5469C188.85 13.5469 188.432 13.6445 188.073 13.8398C187.722 14.0273 187.425 14.2891 187.182 14.625C186.948 14.9609 186.768 15.3477 186.643 15.7852C186.518 16.2227 186.456 16.6953 186.456 17.2031ZM203.079 11.3203V13.5469H195.814V11.3203H203.079ZM197.759 8.20312H200.864V20.3438C200.864 20.7188 200.915 21.0078 201.017 21.2109C201.118 21.4141 201.271 21.5508 201.474 21.6211C201.677 21.6914 201.919 21.7266 202.2 21.7266C202.403 21.7266 202.591 21.7148 202.763 21.6914C202.935 21.668 203.079 21.6445 203.196 21.6211L203.208 23.9414C202.95 24.0273 202.657 24.0977 202.329 24.1523C202.009 24.207 201.646 24.2344 201.239 24.2344C200.544 24.2344 199.935 24.1172 199.411 23.8828C198.888 23.6406 198.482 23.2539 198.193 22.7227C197.903 22.1836 197.759 21.4727 197.759 20.5898V8.20312ZM214.166 20.9531L216.943 11.3203H218.912L218.326 14.6484L215.525 24H213.826L214.166 20.9531ZM212.63 11.3203L214.716 20.9766L214.904 24H212.947L209.619 11.3203H212.63ZM221.49 20.8359L223.529 11.3203H226.529L223.224 24H221.267L221.49 20.8359ZM219.216 11.3203L221.97 20.8594L222.334 24H220.634L217.81 14.6484L217.236 11.3203H219.216ZM231.211 13.9102V24H228.117V11.3203H231.047L231.211 13.9102ZM235.066 11.2383L235.019 14.1211C234.848 14.0898 234.652 14.0664 234.433 14.0508C234.223 14.0352 234.023 14.0273 233.836 14.0273C233.359 14.0273 232.941 14.0938 232.582 14.2266C232.223 14.3516 231.922 14.5352 231.68 14.7773C231.445 15.0195 231.265 15.3164 231.14 15.668C231.015 16.0117 230.945 16.4023 230.93 16.8398L230.262 16.7578C230.262 15.9531 230.344 15.207 230.508 14.5195C230.672 13.832 230.91 13.2305 231.223 12.7148C231.535 12.1992 231.926 11.8008 232.394 11.5195C232.871 11.2305 233.418 11.0859 234.035 11.0859C234.207 11.0859 234.39 11.1016 234.586 11.1328C234.789 11.1562 234.949 11.1914 235.066 11.2383ZM235.647 17.7891V17.543C235.647 16.6133 235.779 15.7578 236.045 14.9766C236.311 14.1875 236.697 13.5039 237.205 12.9258C237.713 12.3477 238.334 11.8984 239.068 11.5781C239.803 11.25 240.639 11.0859 241.576 11.0859C242.529 11.0859 243.373 11.25 244.107 11.5781C244.85 11.8984 245.475 12.3477 245.982 12.9258C246.49 13.5039 246.877 14.1875 247.143 14.9766C247.408 15.7578 247.541 16.6133 247.541 17.543V17.7891C247.541 18.7109 247.408 19.5664 247.143 20.3555C246.877 21.1367 246.49 21.8203 245.982 22.4062C245.475 22.9844 244.854 23.4336 244.119 23.7539C243.385 24.0742 242.545 24.2344 241.6 24.2344C240.662 24.2344 239.822 24.0742 239.08 23.7539C238.338 23.4336 237.713 22.9844 237.205 22.4062C236.697 21.8203 236.311 21.1367 236.045 20.3555C235.779 19.5664 235.647 18.7109 235.647 17.7891ZM238.74 17.543V17.7891C238.74 18.3438 238.795 18.8633 238.904 19.3477C239.014 19.832 239.182 20.2578 239.408 20.625C239.635 20.9922 239.928 21.2812 240.287 21.4922C240.654 21.6953 241.092 21.7969 241.6 21.7969C242.1 21.7969 242.529 21.6953 242.889 21.4922C243.248 21.2812 243.541 20.9922 243.768 20.625C244.002 20.2578 244.174 19.832 244.283 19.3477C244.393 18.8633 244.447 18.3438 244.447 17.7891V17.543C244.447 16.9961 244.393 16.4844 244.283 16.0078C244.174 15.5234 244.002 15.0977 243.768 14.7305C243.541 14.3555 243.244 14.0625 242.877 13.8516C242.518 13.6328 242.084 13.5234 241.576 13.5234C241.076 13.5234 240.647 13.6328 240.287 13.8516C239.928 14.0625 239.635 14.3555 239.408 14.7305C239.182 15.0977 239.014 15.5234 238.904 16.0078C238.795 16.4844 238.74 16.9961 238.74 17.543ZM252.586 14.0273V24H249.492V11.3203H252.399L252.586 14.0273ZM252.094 17.2031H251.18C251.188 16.2812 251.313 15.4453 251.555 14.6953C251.797 13.9453 252.137 13.3008 252.575 12.7617C253.02 12.2227 253.547 11.8086 254.157 11.5195C254.766 11.2305 255.446 11.0859 256.196 11.0859C256.805 11.0859 257.356 11.1719 257.848 11.3438C258.34 11.5156 258.762 11.7891 259.114 12.1641C259.473 12.5391 259.746 13.0312 259.934 13.6406C260.129 14.2422 260.227 14.9844 260.227 15.8672V24H257.11V15.8438C257.11 15.2656 257.024 14.8086 256.852 14.4727C256.688 14.1367 256.446 13.8984 256.125 13.7578C255.813 13.6172 255.426 13.5469 254.965 13.5469C254.489 13.5469 254.071 13.6445 253.711 13.8398C253.36 14.0273 253.063 14.2891 252.821 14.625C252.586 14.9609 252.407 15.3477 252.282 15.7852C252.157 16.2227 252.094 16.6953 252.094 17.2031ZM270.78 11.3203H273.592V23.6133C273.592 24.7617 273.342 25.7344 272.842 26.5312C272.35 27.3359 271.659 27.9453 270.768 28.3594C269.878 28.7812 268.842 28.9922 267.663 28.9922C267.155 28.9922 266.604 28.9219 266.01 28.7812C265.424 28.6406 264.858 28.418 264.311 28.1133C263.772 27.8164 263.323 27.4297 262.963 26.9531L264.358 25.125C264.78 25.6172 265.256 25.9883 265.788 26.2383C266.319 26.4961 266.893 26.625 267.51 26.625C268.135 26.625 268.667 26.5078 269.104 26.2734C269.549 26.0469 269.889 25.7109 270.124 25.2656C270.366 24.8281 270.487 24.2891 270.487 23.6484V14.2148L270.78 11.3203ZM262.213 17.8125V17.5664C262.213 16.5977 262.331 15.7188 262.565 14.9297C262.799 14.1328 263.135 13.4492 263.573 12.8789C264.018 12.3086 264.553 11.8672 265.178 11.5547C265.811 11.2422 266.522 11.0859 267.311 11.0859C268.147 11.0859 268.85 11.2383 269.42 11.543C269.999 11.8477 270.475 12.2812 270.85 12.8438C271.233 13.4062 271.53 14.0742 271.741 14.8477C271.96 15.6133 272.128 16.457 272.245 17.3789V18.0469C272.135 18.9453 271.96 19.7695 271.717 20.5195C271.483 21.2695 271.17 21.9258 270.78 22.4883C270.389 23.043 269.905 23.4727 269.327 23.7773C268.749 24.082 268.069 24.2344 267.288 24.2344C266.506 24.2344 265.803 24.0742 265.178 23.7539C264.553 23.4336 264.018 22.9844 263.573 22.4062C263.135 21.8281 262.799 21.1484 262.565 20.3672C262.331 19.5859 262.213 18.7344 262.213 17.8125ZM265.307 17.5664V17.8125C265.307 18.3594 265.362 18.8711 265.471 19.3477C265.581 19.8242 265.749 20.2461 265.975 20.6133C266.202 20.9727 266.487 21.2539 266.831 21.457C267.174 21.6602 267.585 21.7617 268.061 21.7617C268.702 21.7617 269.225 21.6289 269.631 21.3633C270.045 21.0898 270.358 20.7188 270.569 20.25C270.788 19.7734 270.928 19.2383 270.991 18.6445V16.8047C270.952 16.3359 270.866 15.9023 270.733 15.5039C270.608 15.1055 270.432 14.7617 270.206 14.4727C269.979 14.1836 269.69 13.957 269.338 13.793C268.987 13.6289 268.569 13.5469 268.085 13.5469C267.616 13.5469 267.206 13.6523 266.854 13.8633C266.503 14.0664 266.213 14.3516 265.987 14.7188C265.76 15.0859 265.588 15.5117 265.471 15.9961C265.362 16.4805 265.307 17.0039 265.307 17.5664Z" fill="#CC0905"/>
                <defs>
                <clipPath id="clip0_17448_26621">
                <rect width="24" height="24" fill="white" transform="translate(0 4)"/>
                </clipPath>
                </defs>
                </svg>

                <p className="text-[#1A2024] text-base leading-relaxed max-w-2xl mt-2">
               Something went wrong while processing your One App payment. This may happen if you don’t have a One App account or due to a temporary issue. Please try again or choose a different payment method.</p>
              </div>
            </div>

            {/* Go Back Button */}
          <div className=" flex justify-start my-12">
            <button
              onClick={handleGoBackFromError}
              className="px-6 py-3 bg-white border border-gray-300 text-[#1A2024] rounded-md hover:bg-gray-50 transition-colors font-bold"
            >
              Go Back and Try Again
            </button>
          </div>
          {/* Download Section */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-black mb-3  tracking-wider">
              If you don’t have a One App account, please download the app and create one to proceed
            </h3>
            <div className="flex gap-3 flex-wrap">
              <a
                href="https://apps.apple.com/bh/app/one-marketplace/id6737277998"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={appleLogo}
                  alt="Download on the App Store"
                  className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=bh.one.app&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={googleLogo}
                  alt="Get it on Google Play"
                  className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
            </div>
          </div>
          </div>

          

          

          {/* Footer */}
          <footer className="mt-8">
            <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%] mb-1">
              Solidarity Bahrain is a Subsidiary of Solidarity Group Holding
            </p>
            <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%]">
              Licensed and regulated by the Central Bank of Bahrain as a locally incorporated Takaful Firm – Category four
            </p>
          </footer>
        </div>
      ) : (
        <div className="p-12 w-[48%] mt-[7%] mx-auto bg-[#F6F8F9] rounded-[26px] max767:pt-8 max767:mt-0 max767:p-5 max767:w-[100%] max767:rounded-none ipad:w-[95%] ipad:mt-[14%]">
          <div className="flex justify-between items-center mt-0 mb-12 max767:grid max767:mb-[24px]">
            <h2 className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:w-full  max767:order-2 ">
              Payment Method
            </h2>
            <img
              src={logo}
              alt="Solidarity Logo"
              className="h-10 max767:flex max767:order-1 max767:mb-[16px]"
            />
          </div>

          <div className="mb-4 flex flex-col items-start self-stretch border bg-white rounded-[10px] ">
            <h3 className="text-[#1A2024] text-base not-italic font-medium leading-6 border-b px-6 py-4 w-full">
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md mb-2"></div>
              ) : (
                <p className=" text-[#5B6871] text-base not-italic font-normal leading-6">
                  Name
                </p>
              )}
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md"></div>
              ) : (
                paymentData.name
              )}
            </h3>
            <div className="border-b w-full px-6 py-4">
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md mb-2"></div>
              ) : (
                <p className=" text-[#5B6871] text-base not-italic font-normal leading-6">
                  Quote Number
                </p>
              )}

              <p className="text-[#1A2024] text-base not-italic font-medium leading-6">
                {isLoading ? (
                  <div className="w-full h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md"></div>
                ) : (
                  paymentData.quotationNumber
                )}
              </p>
            </div>
            <div className="border-b w-full px-6 py-4">
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md mb-2"></div>
              ) : (
                <p className=" text-[#5B6871] text-base not-italic font-normal leading-6">
                  Description
                </p>
              )}
              <p className="text-[#1A2024] text-base not-italic font-medium leading-6">
                {isLoading ? (
                  <div className="w-full h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md mb-2"></div>
                ) : (
                  paymentData.planName
                )}
              </p>
              <p className="text-[#1A2024] text-base not-italic font-medium leading-6">
                {isLoading ? (
                  <div className="w-full h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md"></div>
                ) : (
                  paymentData.description
                )}
              </p>
            </div>
            <h3 className="text-[#1A2024] text-base not-italic font-medium leading-6 border-b px-6 py-4 w-full">
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md mb-2"></div>
              ) : (
                <p className=" text-[#5B6871] text-base not-italic font-normal leading-6">
                  Amount
                </p>
              )}
              {isLoading ? (
                <div className="w-40 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md"></div>
              ) : (
                `BHD ${paymentData.amount}`
              )}
            </h3>
          </div>
          {paymentData.requestType == "Policy" &&
          paymentData.ProductName != "" ? (
            isQuoteLoading ? (
              <div className="text-center pb-2">
                <div
                  className="inline-block size-6 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"
                  role="status"
                  aria-label="Loading"
                ></div>
              </div>
            ) : (
              <div
                className={`text-center pb-2  ${File == "" ? "hidden" : ""}`}
              >
                <a
                  href={File}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline underline-offset-2 decoration-2 hover:text-blue-800"
                >
                  View Quote
                </a>
              </div>
            )
          ) : (
            ""
          )}
          <div className="mb-4 flex items-center gap-3">
            <div className="h-px flex-1 bg-gray-200" />
            <span className="text-sm font-medium text-gray-600 tracking-wide">
              PAY USING
            </span>
            <div className="h-px flex-1 bg-gray-200" />
          </div>

          {/* ---------- ONE banner ABOVE the tiles ---------- */}
          {!isLoading &&
            !paymentData.isPaid &&
            (!paymentData.expiryDate ||
              new Date() <= new Date(paymentData.expiryDate)) &&
            paymentData.requestType === "Policy" && // allowed per your original checks
            paymentData.sourceOfBusiness === "DIRECT" && // Only show for DIRECT source
            paymentData.amount > 30 && // Only show if amount is greater than 30
            paymentMethods
              .filter((m) => m.name === "One")
              .map((method, index) => {
                const total = Number(
                  paymentData?.amount ?? paymentData?.totalAmount ?? 0
                );
                const installment =
                  total > 0
                    ? (total / 12).toLocaleString(undefined, {
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3,
                      })
                    : null;

                return (
                  <div
                    key={`one-banner-top-${index}`}
                    onClick={() => MethodSelected(method.name)}
                    className={`mb-3 w-full flex flex-col justify-center items-start gap-3 border bg-white p-4 rounded-[10px] border-solid border-[#DDE2E4] hover:shadow-lg transition-shadow max767:w-[100%] cursor-pointer ${
                      isCreditCard
                        ? "hidden"
                        : isApplePaySelected
                        ? "hidden"
                        : isOneAppSelected
                        ? "hidden"
                        : ""
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <img
                        src={method.icon}
                        alt="One icon"
                        className="h-[48px] w-auto object-contain"
                        loading="lazy"
                      />
                      <div className="flex flex-col">
                        <div className="text-[#1A2024] text-sm sm:text-base font-medium">
                          Split it into 12 payments
                          {installment ? (
                            <>
                              {" "}
                              of <strong>BHD {installment}</strong>
                            </>
                          ) : null}
                        </div>
                        <div className="text-xs text-gray-500">
                          Subject to One App Approval
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

          {/* ---------------- TILE CONTAINER ---------------- */}
          <div
            className={`flex gap-2 mb-12 justify-around ipad:items-center max767:flex max767:flex-col max767:items-center max767:gap-2 max767:self-stretch ipad:gap-2 ipadself-stretch max767:mb-[24px]`}
          >
            {isLoading ? (
              Array(2)
                .fill(0)
                .map((_, index) => (
                  <div
                    key={index}
                    className="w-full flex flex-col justify-center items-start gap-4 border bg-white p-6 rounded-[10px] animate-pulse"
                  >
                    <Skeleton height={20} width={100} />
                    <Skeleton height={40} width={100} />
                  </div>
                ))
            ) : paymentData.isPaid && paymentData.isSuccess ? (
              <div
                className={`w-full flex justify-center items-start gap-4 border bg-green-200 p-6 rounded-[10px] border-solid border-[#DDE2E4]  transition-shadow max767:w-[100%] `}
              >
                <div className="max767:flex max767:w-full max767:justify-between max767:items-center">
                  <span className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:order-1">
                    Successfully Paid
                  </span>
                </div>
              </div>
            ) : paymentData.isPaid && !paymentData.isSuccess ? (
              <div
                className={`w-full flex justify-center items-start gap-4 border bg-blue-200 p-6 rounded-[10px] border-solid border-[#DDE2E4]  transition-shadow max767:w-[100%] `}
              >
                <div className="max767:flex max767:w-full max767:justify-between max767:items-center">
                  <span className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:order-1">
                    Paid - Pending Approval
                  </span>
                </div>
              </div>
            ) : !paymentData.isPaid && !paymentData.expiryDate ? (
              // -------- Branch A: user choosing method (no expiry) --------
              paymentMethods
                .filter((m) => m.name !== "One") // skip One; banner already above
                .map((method, index) => {
                  if (
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "Apple Pay") ||
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "Debit Card") ||
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "One") ||
                    (paymentData.requestType !== "Policy" &&
                      method.name === "One") ||
                    (paymentData.sourceOfBusiness !== "DIRECT" &&
                      method.name === "One") ||
                    (paymentData.amount <= 30 &&
                      method.name === "One")
                  ) {
                    return null;
                  }
                  if (method.name === "Apple Pay" && !isApplePayVisible) {
                    return null;
                  }
                  return (
                    <div
                      key={index}
                      onClick={() => MethodSelected(method.name)}
                      className={`w-full flex w-40 flex-col justify-center items-start gap-4 border bg-white p-6 rounded-[10px] border-solid border-[#DDE2E4] hover:shadow-lg transition-shadow max767:w-[100%] cursor-pointer ${
                        isCreditCard || isOneAppSelected ? "hidden" : ""
                      }`}
                    >
                      <div className="max767:flex max767:w-full max767:justify-between max767:items-center">
                        <img
                          src={method.icon}
                          alt={`${method.name} icon`}
                          className={`w-max mb-2 max767:order-2 object-contain`}
                          loading="lazy"
                        />
                        <span className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:order-1">
                          {method.name}
                        </span>
                      </div>
                    </div>
                  );
                })
            ) : !paymentData.isPaid &&
              new Date() > new Date(paymentData.expiryDate) ? (
              <div
                className={`w-full flex justify-center items-start gap-4 border bg-red-200 p-6 rounded-[10px] border-solid border-[#DDE2E4]  transition-shadow max767:w-[100%] `}
              >
                <div className="max767:flex max767:w-full max767:justify-between max767:items-center">
                  <span className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:order-1">
                    Expired
                  </span>
                </div>
              </div>
            ) : (
              // -------- Branch B: user choosing method (not expired) --------
              paymentMethods
                .filter((m) => m.name !== "One") // skip One; banner already above
                .map((method, index) => {
                  if (
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "Apple Pay") ||
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "Debit Card") ||
                    (paymentData.requestType === "ForRecurring" &&
                      method.name === "One") ||
                    (paymentData.requestType !== "Policy" &&
                      method.name === "One") ||
                    (paymentData.sourceOfBusiness !== "DIRECT" &&
                      method.name === "One") ||
                    (paymentData.amount <= 30 &&
                      method.name === "One")
                  ) {
                    return null;
                  }
                  if (method.name === "Apple Pay" && !isApplePayVisible) {
                    return null;
                  }
                  return (
                    <div
                      key={index}
                      onClick={() => MethodSelected(method.name)}
                      className={`w-full flex w-40 flex-col justify-center items-start gap-4 border bg-white p-6 rounded-[10px] border-solid border-[#DDE2E4] hover:shadow-lg transition-shadow max767:w-[100%] cursor-pointer ${
                        isCreditCard
                          ? "hidden"
                          : isApplePaySelected
                          ? "hidden"
                          : isOneAppSelected
                          ? "hidden"
                          : ""
                      }`}
                    >
                      <div className="max767:flex max767:w-full max767:justify-between max767:items-center">
                        <img
                          src={method.icon}
                          alt={`${method.name} icon`}
                          className={`w-max mb-2 max767:order-2 ${
                            method.name === "One" ? "h-[50px]" : ""
                          } object-contain`}
                          loading="lazy"
                        />
                        <span className="text-[#1A2024] text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:order-1">
                          {method.name == "One" ? "Marketplace" : method.name}
                        </span>
                      </div>
                    </div>
                  );
                })
            )}

            <div className={`w-full ${isCreditCard ? "" : "hidden"}`}>
              <PaymentPage
                setCreditCard={setCreditCard}
                paymentData={paymentData}
                setLoading={setLoading}
                cancelSelectionCredit={cancelSelectionCredit}
              />
            </div>

            <div className={`w-full ${isOneAppSelected ? "" : "hidden"}`}>
              <div className="flex justify-center ">
                <a
                  href="https://apps.apple.com/bh/app/one-marketplace/id6737277998"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={(e) => e.stopPropagation()} // optional if this sits inside another clickable card
                >
                  <img
                    src={appleLogo}
                    alt="Get One Marketplace on the App Store"
                    className="cursor-pointer p-2"
                  />
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=bh.one.app&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={(e) => e.stopPropagation()} // optional if this sits inside another clickable card
                >
                  <img
                    src={googleLogo}
                    alt="Get One Marketplace on the App Store"
                    className="cursor-pointer p-2"
                  />
                </a>
              </div>
            </div>
          </div>

          {isApplePayVisible &&
          isApplePaySelected &&
          !isCreditCard &&
          !isOneAppSelected &&
          !paymentData.isPaid &&
          new Date() < new Date(paymentData.expiryDate) &&
          !isApplePayLoading ? (
            <>
              <div
                ref={loadingRef}
                className="animate-pulse bg-gray-300 rounded-md h-[52px] w-full mb-2"
              ></div>

              <div
                ref={wrapperRef}
                style={{
                  opacity: 0,
                  pointerEvents: "none",
                  transition: "opacity 0.3s ease",
                  minHeight: "52px", // to prevent layout jump
                }}
              >
                <ApplePayButton
                  debug={process.env.REACT_APP_DEBUG}
                  scope="TapToken"
                  publicKey={process.env.REACT_APP_BUNDLE_ID}
                  environment={process.env.REACT_APP_APPLE_ENV}
                  merchant={{
                    domain: process.env.REACT_APP_APPLE_DOMAIN,
                    id: process.env.REACT_APP_APPLE_MERCHANT_ID,
                  }}
                  acceptance={{
                    supportedBrands: ["masterCard", "visa"],
                  }}
                  features={{
                    supportsCouponCode: false,
                  }}
                  transaction={{
                    currency: "BHD",
                    amount: paymentData.amount.toString(),
                  }}
                  customer={{
                    id: paymentData.custId,
                  }}
                  interface={{
                    locale: "en",
                    theme: "dark",
                    type: "buy",
                    edges: "curved",
                  }}
                  onCancel={() => {
                    // it's called when the user cancels the payment
                    console.log("onCancel");
                  }}
                  onError={(error) => {
                    console.error("Apple Pay Error:", error);

                    // Try to extract more details from error object
                    let message = "";
                    if (error.response && error.response.data) {
                      message = JSON.stringify(error.response.data, null, 2);
                    } else if (error.message) {
                      message = error.message;
                    } else {
                      message = JSON.stringify(error, null, 2);
                    }

                    alert("Apple Pay Error:\n" + message);
                  }}
                  onReady={() => {
                    if (onReadyCalled.current) return;
                    onReadyCalled.current = true;

                    console.log("✅ Apple Pay is truly ready");

                    // ✅ Show the button using DOM manipulation only
                    if (wrapperRef.current) {
                      wrapperRef.current.style.opacity = "1";
                      wrapperRef.current.style.pointerEvents = "auto";
                    }

                    // ✅ Hide the loading message
                    if (loadingRef.current) {
                      loadingRef.current.style.display = "none";
                    }
                  }}
                  onSuccess={async (data, event) => {
                    // it's called when the payment is successful
                    console.log("onSuccess", data);
                    await SaveApplePayPayment(JSON.stringify(data));
                    if (paymentData.requestType == "Policy") {
                      var decryptedData = await DecryptToken(id);
                      var res = await CreateApplePayCharge(data.id);
                      window.location.href =
                        process.env.REACT_APP_SB_HUB +
                        "policy-documents?policy=" +
                        paymentData.quotationNumber +
                        "&id=" +
                        decryptedData.id;
                    } else if (
                      paymentData.requestType == "depreciation" ||
                      paymentData.requestType == "deductible"
                    ) {
                      var decryptedData = await DecryptToken(id);
                      var res = await CreateApplePayCharge(data.id);
                      window.location.href =
                        process.env.REACT_APP_SB_HUB +
                        "policy-documents?policy=" +
                        paymentData.quotationNumber +
                        "&id=" +
                        decryptedData.id;
                    } else {
                      var res = await CreateApplePayCharge(data.id);
                      window.location.href = res.redirectionLink;
                    }

                    // event is the same as the event in the onpaymentauthorized event https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentauthorizedevent
                    console.log("apple pay event", event);
                  }}
                />
              </div>
            </>
          ) : (
            ""
          )}

          <footer className=" ">
            {isLoading ? (
              <div className="w-full h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse rounded-md"></div>
            ) : (
              <>
                <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%]">
                  Solidarity Bahrain is a Subsidiary of Solidarity Group Holding{" "}
                </p>
                <p className="text-[#5B6871] text-xs not-italic font-normal leading-[150%]">
                  Licensed and regulated by the Central Bank of Bahrain as a
                  locally incorporated Takaful Firm – Category four
                </p>
              </>
            )}
          </footer>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default MainPaymentPage;
